import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=3c9df808&scoped=true"
import script from "./AvatarMenu.vue?vue&type=script&lang=ts"
export * from "./AvatarMenu.vue?vue&type=script&lang=ts"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=3c9df808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9df808",
  null
  
)

export default component.exports